class CategoryStartWith {
    id: number;
    foundIn: string;
    episode: {
        id: number;
        meta: {
            season: string;
        }
    }
    bookmark: {
        percent: number;
    }

    constructor(data: any) {
        this.id = data.id || null;
        this.foundIn = data.foundIn;
        this.episode = data.episode;
        this.bookmark = data.bookmark;
    }

    get percent10(): number {
        return Math.ceil(this.bookmark.percent / 10) * 10;
    }
}

export default CategoryStartWith;